import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import { getSearchListTestimonialCategories } from '../../services/content.service';

const TestimonialCategories = ({
  id,
  name,
  defaultValue,
  label,
  onChange,
  sx,
  error,
}) => {
  const [booksData, setBooksData] = useState([]);

  useEffect(() => {
    getSearchListTestimonialCategories()
      .then((res) => {
        setBooksData(res.data);
      })
      .catch(() => {
        // nothing
      });
  }, []);

  return (
    <FormControl fullWidth error={error !== ''}>
      <InputLabel id={`field-${id}-select-label`}>{label}</InputLabel>

      <Select
        labelId="demo-simple-select-label"
        id={id}
        name={name}
        value={defaultValue}
        label={label}
        onChange={onChange}
        sx={sx}
      >
        {booksData.map((k) => (
          <MenuItem key={`${id}-v-${k.id}`} value={`${k.id}`}>
            {`${k.title}`}
          </MenuItem>
        ))}
      </Select>

      {error !== '' && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

TestimonialCategories.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.shape(),
  error: PropTypes.string,
};
TestimonialCategories.defaultProps = {
  sx: {},
  error: '',
};

export default TestimonialCategories;
